import React, { useMemo, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import { Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import axios from 'axios';
import * as yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { FormError } from '~/components/form/FormError';
import { PresetAutocomplete } from '../PresetAutocomplete';
const formSchema = yup
    .object({
    intervention: yup.string().required('Intervention is required'),
    frequency: yup.string().required('Frequency is required'),
    interventionDescription: yup.string().nullable()
})
    .required();
export const AddInterventionModal = (props) => {
    const { onRequestClose, itemToEdit, patientId, onSuccess } = props;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const methods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            intervention: itemToEdit ? itemToEdit.intervention : '',
            frequency: itemToEdit ? itemToEdit.frequency : '',
            interventionDescription: itemToEdit ? itemToEdit.interventionDescription : ''
        },
    });
    const { formState: { errors }, handleSubmit, register, } = methods;
    const onFormSubmit = async ({ intervention, frequency, interventionDescription }) => {
        setIsSubmitting(true);
        const data = {
            intervention: intervention == '' ? null : intervention,
            frequency: frequency == '' ? null : frequency,
            interventionDescription: interventionDescription == '' ? null : interventionDescription
        };
        if (itemToEdit) {
            const response = await axios.post('/api/carePlan/editIntervention', {
                interventionId: itemToEdit.id,
                intervention: data.intervention,
                frequency: data.frequency,
                interventionDescription: data.interventionDescription
            });
            const new_intervention = response.data.data.new_intervention;
            const updatedIntervention = {
                id: new_intervention.id,
                patientId: new_intervention.patient_id,
                carePlanId: new_intervention.care_plan_id,
                intervention: new_intervention.intervention,
                frequency: new_intervention.frequency,
                interventionDescription: new_intervention.intervention_description,
                updatedAt: new Date(new_intervention.updated_at),
                deletedAt: new Date(new_intervention.deleted_at),
                createdAt: new Date(new_intervention.created_at),
                isEditable: new_intervention.is_editable,
                month: new_intervention.month
            };
            onSuccess(updatedIntervention);
        }
        else {
            const response = await axios.post('/api/carePlan/addIntervention', {
                patientId: patientId,
                intervention: data.intervention,
                frequency: data.frequency,
                interventionDescription: data.interventionDescription
            });
            const new_intervention = response.data.data.new_intervention;
            const updatedIntervention = {
                id: new_intervention.id,
                patientId: new_intervention.patient_id,
                carePlanId: new_intervention.care_plan_id,
                intervention: new_intervention.intervention,
                frequency: new_intervention.frequency,
                interventionDescription: new_intervention.intervention_description,
                updatedAt: new Date(new_intervention.updated_at),
                deletedAt: new Date(new_intervention.deleted_at),
                createdAt: new Date(new_intervention.created_at),
                isEditable: new_intervention.is_editable,
                month: new_intervention.month
            };
            onSuccess(updatedIntervention);
        }
        setIsSubmitting(false);
    };
    const presetsByField = useMemo(() => {
        return props.presets.reduce((acc, preset) => {
            (acc[preset.field] ||= []).push(preset);
            return acc;
        }, {});
    }, [props.presets]);
    return (React.createElement(Dialog, { open: true, PaperProps: {
            sx: { maxHeight: '60vh', maxWidth: '50%', width: '50%' }
        } },
        React.createElement(DialogTitle, { sx: {
                m: 0, p: 2, display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }, id: "customized-dialog-title" },
            itemToEdit ? 'Edit Interventions and Monitoring Plan' : 'Add Interventions and Monitoring Plan',
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(FormProvider, { ...methods },
                React.createElement("form", { onSubmit: handleSubmit(onFormSubmit), noValidate: true },
                    React.createElement("div", { className: "mb-5", style: { marginLeft: 'auto', marginRight: 'auto', width: '70%' } },
                        React.createElement("div", { className: "flex justify-between items-center" },
                            React.createElement("div", { style: { width: '100%' } },
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Intervention"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "intervention", presets: presetsByField['intervention'], category: "intervention", field: "intervention", placeholder: "e.g., Review CGM data & adjust insulin as necessary" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Frequency"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "frequency", presets: presetsByField['frequency'], category: "intervention", field: "frequency", placeholder: "e.g., Monthly" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Description/Notes"),
                                React.createElement("div", { className: "row" },
                                    React.createElement("textarea", { className: 'problem-list-scroll', onKeyDown: (event) => event.stopPropagation(), style: {
                                            fontFamily: 'Barlow',
                                            verticalAlign: 'top',
                                            overflowY: 'scroll',
                                            height: '85px',
                                            padding: '10px',
                                            width: '100%',
                                            borderWidth: '1px',
                                            borderColor: '#B9B9B9',
                                            borderRadius: '4px'
                                        }, placeholder: 'Enter Notes', ...register('interventionDescription'), defaultValue: itemToEdit?.interventionDescription ?? '' })),
                                React.createElement(FormError, { errors: errors, name: "add-intervention" })))),
                    React.createElement("div", { className: "flex justify-between items-center" },
                        React.createElement(Button, { style: { width: '100%' }, variant: "contained", disabled: isSubmitting, type: "submit", color: "primary" }, itemToEdit ? 'Edit Plan' : 'Add Plan')))))));
};
